// extracted by mini-css-extract-plugin
module.exports = {"container":"Documents_container__3kgoP","lists":"Documents_lists__1U3I5"};